exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-bottom-hist {\n  border-bottom: solid 2px #1c869a;\n}\n.check {\n  margin-top: 2.6em;\n  margin-left: 1em;\n}\n.custom-historico {\n  display: flex;\n  flex-direction: column;\n  padding: 0.4rem 2rem 2rem;\n}\n.show-plus {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tables th,\n.tables td {\n  border: none;\n}\n.tables tr:nth-child(even) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.tables th {\n  background-color: #1c869a;\n  color: white;\n  padding: 8px;\n  border: groove 1px lightgray;\n}\n", ""]);

// exports
